export {default} from './RegisterCohost';



// WEBPACK FOOTER //
// ./src/pages/RegisterCohost/index.ts